<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-11 09:40:47
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-12 17:07:19
 * @FilePath: \xjlightingdp\src\views\HomeView.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="homeBodyBox">
    <div class="headerBox">
      <div class="logo-container">
        <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
      </div>
      <div class="titleText"> <p>{{ areaName }}雷电监测预警平台</p></div>
      <div class="timeBox">{{ currentTime }}</div>
      <el-button type="text" class="logout-btn" @click="handleLogout">
        <i class="el-icon-switch-button"></i>退出登录
      </el-button>
    </div>
    <div class="mainBox">
      <div class="leftBox">
        <div class="time-selector-box">
          <el-date-picker
            v-model="selectTime"
            type="datetime"
            size="small"
            placeholder="选择时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleTimeChange"
          />
          <div class="time-range-label">
            {{ startTime | formatTime }} ~ {{ endTime | formatTime }}
          </div>
        </div>
        <div class="moduleBox">
          <div class="moduleHeader">
            <i class="el-icon-warning moduleIcon"></i>
            <span class="moduleTitle">最新预警</span>
          </div>
          <div class="moduleContent">
            <div c实时电场统计图lass="warning-item">
              <div class="warning-level">
                预警等级：<span class="level-text">{{
                  latestWarning.level
                }}</span>
              </div>
              <div class="warning-index">
                预警指数：<span class="index-text">{{
                  latestWarning.index
                }}</span>
              </div>
              <div class="warning-time">发布时间：{{ latestWarning.time }}</div>
              <div class="warning-area">预警区域：{{ areaName }}</div>
            </div>
          </div>
        </div>
        <div class="moduleBox">
          <div class="moduleHeader">
            <i class="el-icon-s-operation moduleIcon"></i>
            <span class="moduleTitle">大气电场仪数据</span>
          </div>
          <div class="moduleContent">
            <el-table
              :data="deviceListData"
              style="width: 100%; background-color: transparent"
              size="small"
              stripe
              :header-cell-style="{
                background: '#162A50',
                color: '#ffffff',
                borderBottom: '1px solid rgba(42, 142, 241, 0.3)',
              }"
              :cell-style="{
                background: 'transparent',
                color: '#ffffff',
                borderBottom: '1px solid rgba(42, 142, 241, 0.2)',
              }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="deviceName"
                label="电场仪名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="measure_dvt_value"
                label="电场值(V/m)"
              ></el-table-column>
              <el-table-column
                prop="temperature"
                label="温度(°C)"
              ></el-table-column>
              <el-table-column prop="storm_alarm_level" label="状态">
                <template #default="scope">
                  <el-tag
                    :type="scope.row.storm_alarm_level === '0' ? 'success' : 'danger'"
                    size="small"
                  >
                   {{ scope.row.storm_alarm_level === '0' ? '正常' : '告警' }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="moduleBox">
          <div class="moduleHeader">
            <i class="el-icon-s-operation moduleIcon"></i>
            <span class="moduleTitle">实时电场统计图</span>
          </div>
          <div class="moduleContent">
            <div id="barChart" style="width: 100%; height: 100%"></div>
          </div>
        </div>
      </div>
      <div class="centerBox">
        <div class="data-selector">
          <el-radio-group v-model="dataSelector" size="small" @change="handleDataSelectorChange">
               <el-radio-button label="electric">电场监测</el-radio-button>
               <el-radio-button label="watch">雷达监测</el-radio-button>
            <el-radio-button label="radar">雷达外推</el-radio-button>
         
            <el-radio-button label="fusion">融合结果</el-radio-button>
          </el-radio-group>
        </div>
        <!-- <div class="map-controls">
          <el-radio-group v-model="mapControl" size="small">
            <el-radio-button label="radar">雷达</el-radio-button>
            <el-radio-button label="cloud">云图</el-radio-button>
            <el-radio-button label="precipitation">降水</el-radio-button>
          </el-radio-group>
        </div> -->
        <div id="map" class="map-container"></div>
        <div class="map-reset-btn" @click="resetMapView" title="复位">
          <i class="el-icon-refresh"></i>
        </div>
        <div class="playback-bar">
          <div class="playback-controls">
            <i
              class="el-icon-video-play playback-btn"
              @click="togglePlayback"
            ></i>
          </div>
          <div class="playback-slider">
            <el-slider
             v-model="playSliderVal"
            show-stops
            :marks="marks"
            :min="slidMindata"
            :max="slidMaxdata"
              
              height="6px"
            ></el-slider>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <div class="moduleBox">
          <div class="moduleHeader">
            <i class="el-icon-s-data moduleIcon"></i>
            <span class="moduleTitle">预警统计</span>
          </div>
          <div class="moduleContent">
            <div id="radarChart" style="width: 100%; height: 100%"></div>
          </div>
        </div>
        <div class="moduleBox">
          <div class="moduleHeader">
            <i class="el-icon-share moduleIcon"></i>
            <span class="moduleTitle">预警推送</span>
          </div>
          <div class="moduleContent">
            <el-table
              :data="pushData"
              style="width: 100%; background-color: transparent"
              size="small"
              stripe
              :header-cell-style="{
                background: '#162A50',
                color: '#ffffff',
                borderBottom: '1px solid rgba(42, 142, 241, 0.3)',
              }"
              :cell-style="{
                background: 'transparent',
                color: '#ffffff',
                borderBottom: '1px solid rgba(42, 142, 241, 0.2)',
              }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="sendType"
                label="推送类型"
               
              ></el-table-column>
              
              <el-table-column
                prop="sendLevel"
                label="推送等级"
               
              ></el-table-column>
              <el-table-column prop="status" label="状态">
                <template #default="scope">
                  <el-tag
                    type="success"
                    size="small"
                  >
                    成功
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="moduleBox">
          <div class="moduleHeader">
            <i class="el-icon-bell moduleIcon"></i>
            <span class="moduleTitle">告警信息</span>
          </div>
          <div class="moduleContent">
            <el-table
              :data="alarmData"
              style="width: 100%; background-color: transparent"
              size="small"
              stripe
              :header-cell-style="{
                background: '#162A50',
                color: '#ffffff',
                borderBottom: '1px solid rgba(42, 142, 241, 0.3)',
              }"
              :cell-style="{
                background: 'transparent',
                color: '#ffffff',
                fontSize: '10px',
                borderBottom: '1px solid rgba(42, 142, 241, 0.2)',
              }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="dTime"
                label="告警时间"
               
              ></el-table-column>
              <el-table-column prop="level" label="告警等级" >
                <template #default="scope">
                  <span
                    :style="{
                      color:getColor(scope.row.level),
                        
                      fontWeight: 'bold',
                    
                    }"
                  >
                    {{getText(scope.row.level)  }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="location"
                label="告警位置"
               
              >
               <template #default="scope">
                  <span
                  
                  >
                    {{scope.row.lon  }},{{scope.row.lat}}
                  </span>
                  </template>
              </el-table-column>
            
       
            </el-table>
          </div>
        </div>
        <div class="moduleBox">
          <div class="moduleHeader">
            <i class="el-icon-data-line moduleIcon"></i>
            <span class="moduleTitle">雷电预警监测数据</span>
          </div>
          <div class="moduleContent">
            <el-table
              :data="lightningData"
              style="width: 100%; background-color: transparent"
              size="small"
              stripe
              :header-cell-style="{
                background: '#162A50',
                color: '#ffffff',
                borderBottom: '1px solid rgba(42, 142, 241, 0.3)',
              }"
              :cell-style="{
                background: 'transparent',
                color: '#ffffff',
                borderBottom: '1px solid rgba(42, 142, 241, 0.2)',
              }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="datetime"
                label="时间"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="lon"
                label="经度"
              ></el-table-column>
              <el-table-column
                prop="lat"
                label="纬度"
              ></el-table-column>
              <el-table-column prop="status" label="状态" >
                <template #default="scope">
                  <el-tag
                    type="success"
                    size="small"
                  >
                    检验完成
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MapCreate, L, legendColor } from "../map/mapImport";
import Cookies from "js-cookie";
import moment from "moment";
// import '../map/index.js';
import ligthing from "../assets/ligthing.png";
export default {
  data() {
    return {
      areaName: Cookies.get('areaName'),
        girdColor: "white",
      textmarkerLayer: null,
      makerLayer: null,
      deviceMarkerLayer: null,
      FusionLintingData:[],
      LaryerChoose: "fusion",
       slidMindata: 0,
      slidMaxdata: 19,
      timeLineData: 0,
      marks: {
        0: "0°C",
        8: "8°C",
        37: "37°C",
        50: {
          style: {
            color: "#1989FA",
          },
          label: this.$createElement("strong", "50%"),
        },
      },
      currentTime: "",
      map: null,
      latestWarning: {
        level: "黄色",
        index: "45",
        time: "2026-03-11 13:50:00",
        area: "阿克苏地区",
      },
      deviceListData: [],
      stationChartInstance: null,
      stationRecordsData: {},
      lightningData: [],
      radarData: {
        value: [0, 0, 0],
        indicators: [
          { name: "黄色", max: 10 },
          { name: "橙色", max: 10 },
          { name: "红色", max: 10 },
        ],
      },
      radarChartInstance: null,
      pushData: [
        
      ],
      alarmData: [
       
      ],
      electricFieldChart: {
        categories: ["00:00", "04:00", "08:00", "12:00", "16:00", "20:00"],
        data: [85, -92, 110, -78, 95, -88],
      },
      playbackProgress: 0,
      startTime: moment().subtract(40, 'minutes').format('YYYYMMDDHHmmss'),
      endTime: moment().subtract(30, 'minutes').format('YYYYMMDDHHmmss'),
      selectTime: moment().subtract(30, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
      factoryid: 0,
      gridDataList: [],
      chooseGridData: null,
      dataSelector: 'radar',
      mapControl: 'radar',
      radarLayer: null,
      cloudLayer: null,
      precipitationLayer: null,
      playbackTimer: null,
      isPlaying: false,
      playbackSpeed: 1000,
      imgPlayIndex: 0,
      imgIsPlaying: false,
      imgLayer: null,
        waringleavelList: [
        {
          num: 0,
          color: "#e6c700",
          text: "无",
        },
        {
          num: 1,
          color: "#e6c700",
          text: "黄色",
        },
        {
          num: 2,
          color: "#e67b00",
          text: "橙色",
        },
        {
          num: 3,
          color: "#e62600",
          text: "红色",
        },
      ],
    };
  },
  computed: {
    playSliderVal: {
      get() {
        return this.mapControl === 'radar' ? this.imgPlayIndex : this.timeLineData;
      },
      set(val) {
        if (this.mapControl === 'radar') {
          this.imgPlayIndex = val;
          this.changeImgLayer();
        } else {
          this.timeLineData = val;
          this.changeMapGrid();
        }
      }
    }
  },
  mounted() {
    this.factoryid = Cookies.get("factoryid");
    this.updateTime();
    this.timeInterval = setInterval(() => {
      this.updateTime();
    }, 1000);
    this.initMap();
    this.handleDataSelectorChange();
      this.initRadarChart();
      this.initBarChart();
      this.getWarningData()
      this.getDeviceLocation()
      this.getPushdataList()
      this.getWarnNumData()
      this.getInspectionData()
      this.getStationRecords()
      // this.handleMapControlChange()
  },
  watch: {
    mapControl(newVal) {
      if (this.imgIsPlaying) this.stopImgPlayback();
      if (this.isPlaying) this.stopPlayback();
      this.handleMapControlChange()
    }
  },
  beforeDestroy() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    if (this.playbackTimer) {
      clearInterval(this.playbackTimer);
    }
    if (this.map) {
      if (this.radarLayer) {
        this.map.removeLayer(this.radarLayer);
      }
      if (this.cloudLayer) {
        this.map.removeLayer(this.cloudLayer);
      }
      if (this.precipitationLayer) {
        this.map.removeLayer(this.precipitationLayer);
      }
      if (this.currentImageLayer) {
        this.map.removeLayer(this.currentImageLayer);
      }
      this.map.remove();
    }
    if (this.radarChartInstance) {
      this.radarChartInstance.dispose();
    }
    if (this.stationChartInstance) {
      this.stationChartInstance.dispose();
    }
  },
  filters: {
    formatTime(val) {
      if (!val || val.length < 12) return val;
      return val.slice(0, 4) + '-' + val.slice(4, 6) + '-' + val.slice(6, 8) + ' '
        + val.slice(8, 10) + ':' + val.slice(10, 12) + ':' + val.slice(12, 14);
    }
  },
  methods: {
  getWarnNumData(){
    this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        // url: `${this.$url}?interfaceId=getLdWarninfoBytimes&starttime=20240710210000&endtime=20240711212800`
        url: `${this.$url}/bs/getLigintWarnData`,
        data:{
          type : "3",
        }
      }).then((res)=>{
        console.log(res.data.data);
        this.updateRadarChart(res.data.data)
      })
  },
    getInspectionData() {
      const end = moment().format('YYYY-MM-DD HH:mm:ss');
      const start = moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss');
      this.$axios({
        method: 'get',
        url: 'https://www.moodsci.com/xjthunder/inspection/getLdJyResult2',
        params: {
          starttime: start,
          endtime: end
        }
      }).then((res) => {
        console.log('检验数据:', res.data);
        if (res.data && res.data.data) {
          this.lightningData = res.data.data;
        }
      }).catch((error) => {
        console.error('获取检验数据失败:', error);
      });
    },
    getStationRecords() {
      this.$axios({
        method: 'get',
        url: `${this.$url}/station/recentRecords`
      }).then((res) => {
        console.log('实时电场统计:', res.data);
        this.stationRecordsData = res.data && res.data.data ? res.data.data : {};
        this.updateStationChart();
      }).catch((error) => {
        console.error('获取电场统计数据失败:', error);
      });
    },
    handleMapControlChange() {
       if (this.radarLayer) {
        this.map.removeLayer(this.radarLayer);
        this.radarLayer = null;
      }
           if (this.cloudLayer) {
        this.map.removeLayer(this.cloudLayer);
        this.cloudLayer = null;
      }
           if (this.precipitationLayer) {
        this.map.removeLayer(this.precipitationLayer);
        this.precipitationLayer = null;
      }
      if (this.mapControl === 'radar') {
        this.loadRadarImage();
      } else if (this.mapControl === 'cloud') {
        this.loadCloudImage();
      } else if (this.mapControl === 'precipitation') {
        this.loadPrecipitationImage();
      }
    },
    loadRadarImage() {
      if (this.radarLayer) {
        this.map.removeLayer(this.radarLayer);
        this.radarLayer = null;
      }
      this.$axios({
        method: "get",
        url: "https://typhoon.slt.zj.gov.cn/Api/LastRadar",
      }).then((res) => {
        console.log('雷达数据:', res.data);
       
          const base64Image = res.data['radar0_0'];
          const imageUrl = `${base64Image}`;
          console.log(imageUrl);
          
          this.addImageToMap(imageUrl);
          this.radarLayer = this.currentImageLayer;
        
      }).catch((error) => {
        console.error('获取雷达数据失败:', error);
      });
    },
    loadCloudImage() {
      if (this.cloudLayer) {
        this.map.removeLayer(this.cloudLayer);
        this.cloudLayer = null;
      }
      this.$axios({
        method: "get",
        url: "https://typhoon.slt.zj.gov.cn/Api/LeastCloud/?type=3",
      }).then((res) => {
        console.log('云图数据:', res.data);
       
          const base64Image = res.data['cloud3h'];
          const imageUrl = `${base64Image}`;
          this.addImageToMap(imageUrl);
          this.cloudLayer = this.currentImageLayer;
        
      }).catch((error) => {
        console.error('获取云图数据失败:', error);
      });
    },
    loadPrecipitationImage() {
      if (this.precipitationLayer) {
        this.map.removeLayer(this.precipitationLayer);
        this.precipitationLayer = null;
      }
      this.$axios({
        method: "get",
        url: "https://typhoon.slt.zj.gov.cn/Api/LeastRain/24",
      }).then((res) => {
        console.log('降水数据:', res.data);
        const contours = JSON.parse(res.data.contours);
        console.log(contours);
        
        this.addPrecipitationToMap(contours);
      }).catch((error) => {
        console.error('获取降水数据失败:', error);
      });
    },
    addPrecipitationToMap(contours) {
      if (this.precipitationLayer) {
        this.map.removeLayer(this.precipitationLayer);
      }
      const polygons = [];
      contours.forEach((item) => {
        const latLngs = item.latAndLong.map(coord => [coord[0], coord[1]]);
        const color = item.color.split(',').slice(0, 3).join(',');
        const polygon = L.polygon(latLngs, {
          fillColor: `rgb(${color})`,
          fillOpacity: 0.4,
          color: `rgb(${color})`,
          weight: 1,
          opacity: 0.6
        });
        polygons.push(polygon);
      });
      this.precipitationLayer = L.layerGroup(polygons).addTo(this.map);
    },

    addImageToMap(imageUrl) {
      if (this.currentImageLayer) {
        this.map.removeLayer(this.currentImageLayer);
      }
      const bounds = [[18, 73], [54, 135]];
      this.currentImageLayer = L.imageOverlay(imageUrl, bounds, {
        opacity: 0.7,
        interactive: true
      }).addTo(this.map);
      // this.map.fitBounds(bounds);
    },
    getPushdataList(){
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        // url: `${this.$url}?interfaceId=getLdWarninfoBytimes&starttime=20240710210000&endtime=20240711212800`
        url: `${this.$url}/bs/getsendrecord `,
       
      }).then((res)=>{
        console.log(res.data.data);
        this.pushData = res.data.data
      })
    },
    getDeviceLocation(){
      if (!this.devicePane) {
        this.devicePane = this.map.createPane('devicePane');
        this.devicePane.style.zIndex = 500; 
      }
      
      if (this.deviceMarkerLayer != null) {
        this.map.removeLayer(this.deviceMarkerLayer);
        this.deviceMarkerLayer = null;
      }
      
      this.$axios({
        method: "post",
        url: `https://www.moodsci.com/xjthunder/user/getDeviceLocation`,
      }).then((res)=>{
        console.log(res.data);
        if (res.data && res.data.data && res.data.data.length > 0) {
          const deviceList = res.data.data;
          this.deviceListData = deviceList;
          const markerList = [];
          
          deviceList.forEach((device) => {
            const deviceIcon = L.icon({
              iconUrl: require('@/assets/marker.png'),
              iconSize: [25, 41],
              iconAnchor: [12, 41],
              popupAnchor: [1, -34],
              shadowSize: [41, 41]
            });
            
            const marker = L.marker(
              [parseFloat(device.Lat), parseFloat(device.Lon)],
              { 
                icon: deviceIcon,
                pane: this.devicePane
              }
            ).bindPopup(`
              <div style="font-size:14px; min-width: 250px;">
                <strong style="font-size: 16px; color: #2a8ef1;">${device.deviceName}</strong><br>
                <div style="margin-top: 8px;">
                  <div><strong>设备信息：</strong></div>
                  <div>设备编号: ${device.deviceCode || '-'}</div>
                  <div>设备类型: ${device.stationtype || '-'}</div>
                  <div>设备ID: ${device.deviceId || '-'}</div>
                </div>
                <div style="margin-top: 8px;">
                  <div><strong>位置信息：</strong></div>
                  <div>纬度: ${device.Lat || '-'}</div>
                  <div>经度: ${device.Lon || '-'}</div>
                </div>
                <div style="margin-top: 8px;">
                  <div><strong>气象要素：</strong></div>
                  <div>电场值: ${device.measure_value || '-'} V/m</div>
                  <div>平均电场值: ${device.measure_avg_value || '-'} V/m</div>
                  <div>电场变化值: ${device.measure_dvt_value || '-'} V/m</div>
                  <div>温度: ${device.temperature || '-'} °C</div>
                  <div>湿度: ${device.humidity || '-'} %</div>
                  <div>风速: ${device.windSpeed || '-'} m/s</div>
                  <div>风向: ${device.windDirection || '-'}°</div>
                  <div>气压: ${device.pressure || '-'} hPa</div>
                  <div>降雨量: ${device.rainfall || '-'} mm</div>
                  <div>风暴警报等级: ${device.storm_alarm_level || '-'}</div>
                </div>
                <div style="margin-top: 8px;">
                  <div><strong>其他信息：</strong></div>
                  <div>设备转速: ${device.device_rev_speed || '-'} rpm</div>
                  <div>最后更新: ${device.elementtime || '-'}</div>
                  <div>警报时间: ${device.alarmtime || '-'}</div>
                </div>
              </div>
            `);
            
            markerList.push(marker);
          });
          
          this.deviceMarkerLayer = L.layerGroup(markerList).addTo(this.map);
        }
      }).catch((error)=>{
        console.error('获取设备位置失败:', error);
      });
    },
    getWarningData(){
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        // url: `${this.$url}?interfaceId=getLdWarninfoBytimes&starttime=20240710210000&endtime=20240711212800`
        url: `${this.$url}/bs/getLigintWarnData`,
        data:{
          type : "1",
        }
      }).then((res)=>{
        console.log(res.data.data);
        this.alarmData = res.data.data || []
        if (res.data.data && res.data.data.length > 0) {
          let newWarningData = res.data.data[0]
          this.latestWarning = {
            level: this.getText(newWarningData.level),
            index: newWarningData.level,
            time: newWarningData.dTime,
            area: '阿克苏地区',
          }
        }
      }).catch((error)=>{
        console.error('获取预警数据失败:', error);
      })
    },
   getFusionlightningData() {
      if (this.makerLayer != null) {
        this.map.removeLayer(this.makerLayer);
        this.makerLayer = null;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url: `${this.$url}/earlyWarning/getLdWarninfoBytimes?starttime=${this.startTime}&endtime=${this.endTime}`,
      }).then((res) => {
        loading.close();
        if (res.data.data.length == 0) {
          this.$message("无预测闪电");
          return;
        }
        this.FusionLintingData = res.data.data;
        if (this.chooseGridData && this.chooseGridData.fTime) {
          this.funsionfTim = this.chooseGridData.fTime;
        }
        this.showFusionLit();
      }).catch(()=>{
          loading.close();
      });
    },
     getColor(data) {
      if (data == null) {
        return "";
      } else {
        let waringleavelList = this.waringleavelList;
        let myLeavel = waringleavelList.filter((el) => {
          return el.num == data;
        });
        // //console.log(myLeavel);
        return myLeavel[0].color;
      }
    },
    updateRadarChart(warnData) {
      if (!warnData || warnData.length === 0) {
        return;
      }

      const levelNames = warnData.map(item => item.levelName);
      const levelCounts = warnData.map(item => item.count);
      const maxCount = Math.max(...levelCounts, 10);

      this.$set(this.radarData, 'value', levelCounts);
      this.$set(this.radarData, 'indicators', levelNames.map(name => ({
        name: name,
        max: maxCount
      })));

      const getColorByLevel = (levelName) => {
        const levelMap = {
          '黄色': '#e6c700',
          '橙色': '#e67b00',
          '红色': '#e62600'
        };
        return levelMap[levelName] || '#ffffff';
      };

      const indicatorConfig = this.radarData.indicators.map(indicator => ({
        name: indicator.name,
        max: indicator.max,
        textStyle: {
          color: getColorByLevel(indicator.name)
        }
      }));

      if (this.radarChartInstance) {
        this.radarChartInstance.setOption({
          radar: {
            indicator: indicatorConfig
          },
          series: [{
            data: [{
              value: this.radarData.value
            }],
            itemStyle: {
              color: "rgba(42, 142, 241, 0.8)",
              borderColor: "#2a8ef1",
              borderWidth: 2,
            },
            lineStyle: {
              color: "#2a8ef1",
              width: 2,
            },
            areaStyle: {
              color: "rgba(42, 142, 241, 0.4)",
            },
          }]
        }, false);
        this.radarChartInstance.resize();
      }
    },
    getText(data) {
      //console.log(data);
      if (data == null) {
        return "";
      } else {
        let waringleavelList = this.waringleavelList;
        let myLeavel = waringleavelList.filter((el) => {
          return el.num == data;
        });
        //console.log(myLeavel);
        return myLeavel[0].text;
      }
    },
    showFusionLit() {
      //console.log(this.funsionfTim);
      if (this.makerLayer != null) {
        this.map.removeLayer(this.makerLayer);
        this.makerLayer = null;
      }
      let greenIcon = L.icon({
        iconUrl: ligthing,
        iconSize: [20, 20], // size of the icon
      });
      let markerList = [];
      let waringleavelList = this.waringleavelList;
      this.FusionLintingData.map((item) => {
        // //console.log(item);
        if (item.fTime == this.funsionfTim) {
          // let myLeavel = waringleavelList.filter(el => {
          //   return el.num == item.level;
          // });
          // //console.log();
          let t = this;
          // //console.log(t.getText(item.level));
          markerList.push(
            L.marker([item.lat, item.lon], {
              icon: greenIcon,
            }).bindPopup(`
            <div style="font-size:16px;margin-top:10px">时间：${moment(
              item.dTime,
              "YYYYMMDDHHmmss"
            ).format("YYYY-MM-DD HH:mm:ss")}</div>
            <div style="font-size:16px;margin-top:10px">经度：${item.lon}</div>
            <div style="font-size:16px;margin-top:10px">纬度：${item.lat}</div>
            <div style="font-size:16px;margin-top:10px">预警级别(3km)：${t.getText(
              item.level
            )}预警</div>
            <div style="font-size:16px;margin-top:10px">预警级别(6km)：${t.getText(
              item.level12
            )}预警</div>
            <div style="font-size:16px;margin-top:10px">预警级别(9km)：${t.getText(
              item.level18
            )}预警</div>
          
            <div style="font-size:16px;margin-top:10px">预测时效：${
              item.Timeliness
            }分钟</div>
          
            `)
          );
        }
      });
      //console.log(markerList);
      this.makerLayer = L.layerGroup(markerList).addTo(this.map);
    },
    changeMapGrid(){
      this.chooseGridData = this.gridDataList[this.timeLineData];
      this.addMakerToMap();
       this.funsionfTim = this.chooseGridData.fTime;
              this.showFusionLit();
    },
    getlineMarker(time, len) {
      if (!time) return;
      //添加网格
      this.arrLength = len;
      this.slidMaxdata = len;
      let newdate = moment(time, "YYYYMMDDHHmmss").format("HH:mm");
      // //////console.log(newdate);
      let marker = {};
      for (let i = 0; i <= len; i++) {
        //// //////console.log(i);
        if (i % 2 == 0) {
          marker[i] = {
            style: {
              color: "white",
              fontSize: "8px",
            },
            label: moment(newdate, "HH:mm")
              .add(i * 6, "m")
              .format("HH:mm"),
          };
        }
      }
      // //////console.log(marker);
      this.marks = marker;
    },
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hour = String(now.getHours()).padStart(2, "0");
      const minute = String(now.getMinutes()).padStart(2, "0");
      const second = String(now.getSeconds()).padStart(2, "0");
      const weekDays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekDay = weekDays[now.getDay()];
      this.currentTime = `${year}-${month}-${day} ${hour}:${minute}:${second} ${weekDay}`;
    },
    togglePlayback() {
      if (this.mapControl === 'radar') {
        if (this.imgIsPlaying) {
          this.stopImgPlayback();
        } else {
          this.startImgPlayback();
        }
      } else {
        if (this.isPlaying) {
          this.stopPlayback();
        } else {
          this.startPlayback();
        }
      }
    },
    startImgPlayback() {
      if (this.gridDataList.length === 0) {
        this.$message.warning('暂无雷达图片数据');
        return;
      }
      this.imgIsPlaying = true;
      const btn = document.querySelector(".playback-btn");
      if (btn) {
        btn.classList.remove("el-icon-video-play");
        btn.classList.add("el-icon-video-pause");
      }
      this.imgPlayIndex = 0;
      this.changeImgLayer();
      this.playbackTimer = setInterval(() => {
        if (this.imgPlayIndex < this.gridDataList.length - 1) {
          this.imgPlayIndex++;
          this.changeImgLayer();
        } else {
          this.stopImgPlayback();
        }
      }, this.playbackSpeed);
    },
    stopImgPlayback() {
      this.imgIsPlaying = false;
      if (this.playbackTimer) {
        clearInterval(this.playbackTimer);
        this.playbackTimer = null;
      }
      const btn = document.querySelector(".playback-btn");
      if (btn) {
        btn.classList.remove("el-icon-video-pause");
        btn.classList.add("el-icon-video-play");
      }
      this.imgPlayIndex = 0;
    },
    startPlayback() {
      if (this.gridDataList.length === 0) {
        this.$message.warning('暂无数据可播放');
        return;
      }
      this.isPlaying = true;
      const btn = document.querySelector(".playback-btn");
      if (btn) {
        btn.classList.remove("el-icon-video-play");
        btn.classList.add("el-icon-video-pause");
      }
      this.playbackTimer = setInterval(() => {
        if (this.timeLineData < this.gridDataList.length - 1) {
          this.timeLineData++;
          this.changeMapGrid();
        } else {
          this.stopPlayback();
          this.timeLineData = 0;
          this.changeMapGrid();
        }
      }, this.playbackSpeed);
    },
    stopPlayback() {
      this.isPlaying = false;
      if (this.playbackTimer) {
        clearInterval(this.playbackTimer);
        this.playbackTimer = null;
      }
      const btn = document.querySelector(".playback-btn");
      if (btn) {
        btn.classList.remove("el-icon-video-pause");
        btn.classList.add("el-icon-video-play");
      }
    },
    onPlaybackChange(val) {
      //console.log("播放进度变化:", val);
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('password');
        this.$router.push('/');
        this.$message.success('已退出登录');
      }).catch(() => {});
    },
    initMap() {
      const mapCreate = new MapCreate("map");
      this.map = mapCreate.init("map");
          this.map.on("baselayerchange", (e) => {
      if (this.LaryerChoose != "radar") {
        if (e.name.search("行政图") != -1) {
          this.girdColor = "#636363";
          // //console.log("行政图");
        } else if (e.name.search("卫星图") != -1) {
          this.girdColor = "white";
          // //console.log("卫星图");
        } else if (e.name.search("地形图") != -1) {
          // //console.log("地形图");
          this.girdColor = "#276363";
        }
        this.addMakerToMap();
      }
    });

//  this.addTestImageOverlay();
      
      this.map.flyTo([41.17, 80.27], 8);
      this.showNewAreaData()
      this.addRectangle();
      // this.addMarker();
     
      this.getGridDataToMap();
       this.getFusionlightningData();
    },
  
    resetMapView() {
      if (!this.map) return;
      const data = this.chooseGridData;
      if (data && data.left != null && data.right != null && data.bottom != null && data.top != null) {
        const bounds = [[data.bottom, data.left], [data.top, data.right]];
        this.map.flyToBounds(bounds, { padding: [20, 20] });
      } else {
        this.map.flyTo([41.17, 80.27], 8);
      }
    },
    showNewAreaData(){
      let areaJson = Cookies.get("areaCode");
      // console.log(areaJson);
      
      if (!this.areaPane) {
        this.areaPane = this.map.createPane('areaPane');
        this.areaPane.style.zIndex = 400;
      }
      
      this.$axios({
        method: "get",
        url: `https://www.moodsci.com/xjthunder/${areaJson}.json`,
      }).then((res)=>{
        console.log(res.data);
        if (res.data && res.data.features) {
          const geoJsonLayer = L.geoJSON(res.data, {
            style:  {color: 'blue',fillOpacity:0},
            pane: this.areaPane
          }).addTo(this.map);
          
          console.log('GeoJSON layer added:', geoJsonLayer.getBounds());
        }
      }).catch((error)=>{
        console.error('加载区域数据失败:', error);
      });
    },
    handleTimeChange(val) {
      if (!val) return;
      this.endTime = moment(val, 'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmmss');
      this.startTime = moment(val, 'YYYY-MM-DD HH:mm:ss').subtract(10, 'minutes').format('YYYYMMDDHHmmss');
      this.handleDataSelectorChange();
    },
    handleDataSelectorChange() {
       this.playSliderVal=0
      if (this.imgIsPlaying) this.stopImgPlayback();
      if (this.imgLayer) {
        this.map.removeLayer(this.imgLayer);
        this.imgLayer = null;
      }
      if (this.textmarkerLayer != null) {
        this.map.removeLayer(this.textmarkerLayer);
        this.textmarkerLayer = null;
      }
      if (this.dataSelector === 'fusion') {
        this.getFusionlightningData();
        this.getGridDataToMap()
      } else if (this.dataSelector === 'radar') {
        this.getRadarDataToMap();
      } else if (this.dataSelector === 'electric') {
        this.getElectricDataToMap();
      }else if (this.dataSelector === 'watch') {
         this.playSliderVal=10
       this.showImgToMap();
      
      }
    },
      showImgToMap() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url: `https://www.moodsci.com/xjthunder/extrapolation/getLatestRadarImages`,
      }).then((res) => {
        console.log(res.data.data);
        // return
        let imglist = [];
        let imgobj = res.data.data;
        // let mymarkerobj = {};
        for (const key in imgobj) {
          if (Object.hasOwnProperty.call(imgobj, key)) {
            const element = imgobj[key];
            //console.log(element, key);

            imglist.push({
              name: key,
              data: element,
            });
          }
        }

        let newimglist = imglist.sort((a, b) => {
          return a.name - b.name;
        });
        console.log(newimglist);
        let imageBounds = [[39.0301, 77.7842], [43.0975, 83.0888]];
        this.gridDataList = newimglist;
        this.getlineMarker(moment().subtract(1,'h').format("YYYYMMDDHHmmss"), 10);
        if(newimglist[9]!=undefined){
          this.imgLayer = L.imageOverlay(newimglist[9].data, imageBounds, {
          opacity: 0.7,
        }).addTo(this.map);
        }
        
      });
    },
       changeImgLayer() {
      if (this.imgLayer != null) {
        let oldtilePixelLayer = this.imgLayer;
        oldtilePixelLayer.getElement().classList.add("MyImghidden");
        setTimeout(() => {
          this.map.removeLayer(oldtilePixelLayer);
        }, 1000);
      }
      let imageBounds = [[39.0301, 77.7842], [43.0975, 83.0888]];
      let imgData = this.gridDataList[this.imgPlayIndex];
      if (!imgData || !imgData.data) return;
      this.imgLayer = L.imageOverlay(imgData.data, imageBounds, {
        opacity: 0.7,
      }).addTo(this.map);
    },
    getRadarDataToMap() {
      this.$axios({
        method: "post",
        url: `${this.$url}/extrapolation/getGridRadarByTime`,
        data: {
          starttime: this.startTime,
          endtime: this.endTime,
          factory: this.factoryid,
        },
      }).then((res) => {
        if (res.data && res.data.data) {
          this.gridDataList = res.data.data.slice(0, 10);
          this.chooseGridData = res.data.data[0];
          this.addMakerToMap();
          if (res.data.data.length > 0) {
            this.getlineMarker(
              res.data.data[0].dTime,
              res.data.data.slice(0, 10).length
            );
          }
        }
      }).catch((error) => {
        console.error('获取雷达外推数据失败:', error);
      });
    },
    getElectricDataToMap() {
      return
      this.$axios({
        method: "post",
        url: `${this.$url}/extrapolation/getGridElectricByTime`,
        data: {
          starttime: this.startTime,
          endtime: this.endTime,
          factory: this.factoryid,
        },
      }).then((res) => {
        if (res.data && res.data.data) {
          this.gridDataList = res.data.data.slice(0, 10);
          this.chooseGridData = res.data.data[0];
          this.addMakerToMap();
          if (res.data.data.length > 0) {
            this.getlineMarker(
              res.data.data[0].dTime,
              res.data.data.slice(0, 10).length
            );
          }
        }
      }).catch((error) => {
        console.error('获取电场外推数据失败:', error);
      });
    },
    getGridDataToMap() {
      this.$axios({
        method: "post",

        url: `${this.$url}/extrapolation/getGridIntegrationByTime`,
        // url: `${this.$url}?interfaceId=getGridRadarLevel`
        data: {
          starttime: this.startTime,
          endtime: this.endTime,
          factory: this.factoryid,
        },
      }).then((res) => {
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.gridDataList = res.data.data.slice(0, 10);
          this.chooseGridData = res.data.data[0];
          this.addMakerToMap();
          this.getlineMarker(
            res.data.data[0].dTime,
            res.data.data.slice(0, 10).length
          );
        }
      });
    },
    addMakerToMap() {
      let rcoption = 1;
      if (this.isShowrcBoxlayer) {
        rcoption = 1;
      } else {
        rcoption = 0;
      }
      let ledcolorList = JSON.parse(
        JSON.stringify(legendColor[this.dataSelector]),
      );
      //console.log(ledcolorList);
      let data = this.chooseGridData;
      if (!data) return;
      if (this.textmarkerLayer != null) {
        this.map.removeLayer(this.textmarkerLayer);
        this.textmarkerLayer = null;
      }
      let xySum = 1;
      let dataList = [];
      // if (this.checkList == "大风") {
      //   dataList = data.windS.map(item => {
      //     return Number(item);
      //   });
      //   xySum = 1;
      // } else if (this.checkList == "雷达") {
      //   dataList = data.datas.map(item => {
      //     return Number(item);
      //   });
      //   xySum = 10;
      // } else {
      dataList = data && data.datas ? data.datas.split(",").map((item) => {
        return Number(item);
      }) : [];
      //   xySum = 1;
      // }
      //console.log(dataList);
      let index = 0;
      let xq = (data.right - data.left) / data.cols;
      let yq = (data.top - data.bottom) / data.rows;
      let makerList = [];
      for (let i = 0; i < data.rows; i += xySum) {
        for (let k = 0; k < data.cols; k += xySum) {
          let markerIcon = L.divIcon({
            html: `<div class="maerktext" style="color:${this.girdColor}">${dataList[index]}</div>`, //marker标注
            className: "my-div-icon",
            iconSize: [20, 10], //marker宽高
            iconAnchor: [10, 5], //文字标注相对位置
          });
          let color = [0, [255, 255, 255, 0]];
          if (dataList[index] > 0) {
            // //console.log(dataList[index]);
            // //console.log(dataList[index]);
            ledcolorList.map((item, idnex2) => {
              // if()
              // //console.log(ledcolorList[idnex2 + 1]);
              if (ledcolorList[idnex2 + 1] != undefined) {
                if (
                  item[0] <= dataList[index] &&
                  ledcolorList[idnex2 + 1][0] > dataList[index]
                ) {
                  color = item;
                }
              } else {
                if (item[0] <= dataList[index]) {
                  color = item;
                }
              }
            });
          }

          let lonLine = L.rectangle(
            [
              [data.top - yq * i, data.left + xq * k],
              [data.top - yq * (i + 1), data.left + xq * (k + 1)],
            ],
            {
              weight: 1,
              fillColor: `rgb(${color[1][0]}, ${color[1][1]}, ${color[1][2]})`,
              color: this.girdColor,
              fillOpacity: color[1][3],
              opacity: rcoption,
              className: "dashLine",
            },
          );
          // if (this.isShowrcBoxlayer) {
          makerList.push(lonLine);
          // }

          index++;
          makerList.push(
            L.marker(
              [data.top - yq * i - yq / 2, data.left + xq * k + xq / 2],
              {
                icon: markerIcon,
              },
            ),
          );
        }
      }
      this.textmarkerLayer = L.layerGroup(makerList).addTo(this.map);
      
    },
    addRectangle() {
      const roundMap = Cookies.get("roundMap");
      if (roundMap) {
        try {
          const bounds = JSON.parse(roundMap);
          if (Array.isArray(bounds) && bounds.length === 2) {
            const rectangle = L.rectangle(bounds, {
              color: "blue",
              weight: 3,
              fillColor: "#f9ca24",
              fillOpacity: 0,
              dashArray: "5, 10",
            }).addTo(this.map);
            this.map.fitBounds(bounds,{
              maxZoom: 12,
            });

            // 计算矩形中心点
            const center = [
              (bounds[0][0] + bounds[1][0]) / 2,
              (bounds[0][1] + bounds[1][1]) / 2
            ];

            // 添加三个圆，半径分别为3km、6km、9km
            const radiuses = [3000, 6000, 9000];
            const colors = [ '#e62600', '#e67b00','#e6c700']; // 黄色、橙色、红色

            radiuses.forEach((radius, index) => {
              L.circle(center, {
                radius: radius,
                color: colors[index],
                fillColor: colors[index],
                fillOpacity: 0,
                weight: 4
              }).addTo(this.map);
            });
          }
        } catch (error) {
          console.error("解析 roundMap 失败:", error);
        }
      }
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "table-row-even";
      }
      return "table-row-odd";
    },
    initRadarChart() {
      const radarDom = document.getElementById("radarChart");
      if (!radarDom) return;

      this.radarChartInstance = this.$echarts.init(radarDom);

      const option = {
        title: {
          text: "",
          textStyle: {
            color: "#ffffff",
            fontSize: 16,
            fontWeight: "normal",
          },
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(14, 18, 45, 0.9)",
          borderColor: "#2a8ef1",
          borderWidth: 1,
          textStyle: {
            color: "#ffffff",
          },
        },
        radar: {
          shape: "circle",
          center: ["50%", "55%"],
          radius: "70%",
          startAngle: 0,
          splitNumber: 5,
          splitArea: {
            areaStyle: {
              color: [
                "rgba(42, 142, 241, 0.1)",
                "rgba(42, 142, 241, 0.08)",
                "rgba(42, 142, 241, 0.06)",
                "rgba(42, 142, 241, 0.04)",
                "rgba(42, 142, 241, 0.02)",
              ],
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(42, 142, 241, 0.3)",
            },
          },
          indicator: this.radarData.indicators || [],
          axisName: {
            color: "#ffffff",
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(42, 142, 241, 0.3)",
            },
          },
        },
        legend: {
          show: false,
        },
        series: {
          type: "radar",
          data: [
            {
              value: this.radarData.value || [],
              name: "预警数量",
              itemStyle: {
                color: "rgba(42, 142, 241, 0.8)",
                borderColor: "#2a8ef1",
                borderWidth: 2,
              },
              lineStyle: {
                color: "#2a8ef1",
                width: 2,
              },
              areaStyle: {
                color: "rgba(42, 142, 241, 0.4)",
              },
              symbolSize: 8,
              symbol: "circle",
            },
          ],
          smooth: true,
        },
      };

      this.radarChartInstance.setOption(option);

      window.addEventListener("resize", () => {
        this.radarChartInstance.resize();
      });
    },
    initBarChart() {
      const barDom = document.getElementById("barChart");
      if (!barDom) return;
      this.stationChartInstance = this.$echarts.init(barDom);
      this.updateStationChart();
      window.addEventListener("resize", () => {
        this.stationChartInstance && this.stationChartInstance.resize();
      });
    },
    updateStationChart() {
      if (!this.stationChartInstance) return;
      const data = this.stationRecordsData;
      const deviceIds = Object.keys(data);
      if (deviceIds.length === 0) return;

      const firstDevice = data[deviceIds[0]];
      if (!firstDevice || firstDevice.length === 0) return;
      const xData = firstDevice.map((_, i) => i + 1);

      const colors = ['#2a8ef1', '#e6c700', '#e67b00', '#e62600', '#00d68f', '#ff6b9d', '#a78bfa', '#34d399'];
      const series = deviceIds.map((deviceId, idx) => {
        const records = data[deviceId];
        const name = this.getDeviceNameById(deviceId) || deviceId.slice(-6);
        return {
          name: name,
          type: 'line',
          data: records.map(r => parseFloat(r.measure_value) || 0),
          smooth: true,
          symbol: 'circle',
          symbolSize: 4,
          lineStyle: { color: colors[idx % colors.length], width: 2 },
          itemStyle: { color: colors[idx % colors.length] }
        };
      });

      const option = {
        tooltip: { trigger: 'axis', textStyle: { fontSize: 11 } },
        legend: {
          type: 'scroll',
          bottom: 0,
          textStyle: { color: '#ffffff', fontSize: 10 },
          pageTextStyle: { color: '#ffffff' }
        },
        grid: {
          left: '3%', right: '6%', bottom: '18%', top: '8%', containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xData,
          name: '序号',
          nameTextStyle: { color: '#ffffff', fontSize: 11 },
          axisLabel: { color: '#ffffff', fontSize: 10 },
          axisLine: { lineStyle: { color: 'rgba(42, 142, 241, 0.3)' } }
        },
        yAxis: {
          type: 'value',
          name: 'kV/m',
          nameTextStyle: { color: '#ffffff', fontSize: 12 },
          axisLabel: { color: '#ffffff', fontSize: 11 },
          splitLine: { lineStyle: { color: 'rgba(42, 142, 241, 0.2)' } },
          axisLine: { lineStyle: { color: 'rgba(42, 142, 241, 0.3)' } }
        },
        series: series
      };

      this.stationChartInstance.setOption(option, true);
    },
    getDeviceNameById(deviceId) {
      const device = this.deviceListData.find(d => d.deviceId === deviceId);
      return device ? device.deviceName : null;
    },
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}
.homeBodyBox {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #0e122d 0%, #1a1f3d 100%);
  padding: 10px;
}
.headerBox {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 28px;
  font-weight: bold;
  
  text-shadow: 0 0 20px rgba(42, 142, 241, 0.3);
  box-shadow: 0 4px 15px rgba(42, 142, 241, 0.2);
  border-radius: 10px;
  padding: 0 20px;
  margin-bottom: 15px;
}
.logo-container {
  margin-right: 15px;
  display: flex;
  align-items: center;
}
.logo-img {
  height: 40px;
  width: auto;
  object-fit: contain;
}
.titleText {
  text-align: center;
  flex: none;
   background: linear-gradient(to bottom, #003cff , #86c4ff );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
    /* background: linear-gradient(to bottom, #0084ff , #23eb00 ); */
    /* background: linear-gradient(to bottom, #0084ff , #86c4ff );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
}
.timeBox {
  position: absolute;
  right: 150px;
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 8px 16px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.mainBox {
  height: calc(100vh - 95px);
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 15px;
}
.leftBox,
.rightBox {
  height: 100%;
  width: 19%;
  border: 1px solid rgba(42, 142, 241, 0.3);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  background: rgba(14, 18, 45, 0.8);
  backdrop-filter: blur(10px);
  overflow: hidden;
}
.centerBox {
  height: 100%;
  width: 60%;
  border: 1px solid rgba(42, 142, 241, 0.3);
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  background: rgba(14, 18, 45, 0.8);
  backdrop-filter: blur(10px);
  overflow: hidden;
  position: relative;
}
.playback-bar {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 20px;
  background: rgba(14, 18, 45, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 30px;
  border: 1px solid rgba(42, 142, 241, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 1000px;
  justify-content: center;
  z-index: 999;
}
.playback-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}
.playback-btn {
  color: #2a8ef1;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 0 10px rgba(42, 142, 241, 0.5);
}
.playback-btn:hover {
  color: #ffffff;
  transform: scale(1.1);
  text-shadow: 0 0 20px rgba(42, 142, 241, 0.8);
}
.playback-slider {
  flex: 1;
  display: flex;
  align-items: center;
}
.playback-slider .el-slider {
  width: 100%;
}
.playback-slider .el-slider__runway {
  height: 4px;
  border-radius: 2px;
  background: linear-gradient(
    90deg,
    rgba(42, 142, 241, 0.3) 0%,
    rgba(42, 142, 241, 0.6) 100%
  );
  border: none;
}
.playback-slider .el-slider__bar {
  height: 4px;
  border-radius: 2px;
  background: #2a8ef1;
}
.playback-slider .el-slider__button-wrapper {
  top: -18px;
}
.playback-slider .el-slider__button {
  width: 12px;
  height: 12px;
  border: none;
  background: #2a8ef1;
  box-shadow: 0 0 8px rgba(42, 142, 241, 0.8);
  transition: all 0.3s ease;
}
.playback-slider .el-slider__button:hover {
  transform: scale(1.2);
  box-shadow: 0 0 16px rgba(42, 142, 241, 1);
}
.playback-time {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  min-width: 150px;
  text-align: center;
  text-shadow: 0 0 10px rgba(42, 142, 241, 0.5);
}
.time-selector-box {
  padding: 8px 12px;
  border: 1px solid rgba(42, 142, 241, 0.3);
  border-radius: 8px;
  background: rgba(14, 18, 45, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.time-selector-box .el-date-editor {
  width: 100%;
}
.time-range-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
}
.moduleBox {
  flex: 1;
  border: 1px solid rgba(42, 142, 241, 0.3);
  border-radius: 8px;
  background: linear-gradient(
    135deg,
    rgba(14, 18, 45, 0.9) 0%,
    rgba(26, 31, 61, 0.9) 100%
  );
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}
.moduleBox:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(42, 142, 241, 0.3);
  border-color: #2a8ef1;
}
.moduleHeader {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: linear-gradient(
    90deg,
    rgba(42, 142, 241, 0.1) 0%,
    transparent 100%
  );
  border-bottom: 1px solid rgba(42, 142, 241, 0.2);
}
.moduleIcon {
  color: #2a8ef1;
  font-size: 20px;
  margin-right: 10px;
  text-shadow: 0 0 10px rgba(42, 142, 241, 0.5);
}
.moduleTitle {
  color: #ffffff;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: 1px;
}
.moduleContent {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  color: #e0e0e0;
  font-size: 14px;
}
#radarChart {
  width: 100% !important;
  height: 120px !important;
}
.warning-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.warning-level,
.warning-index,
.warning-time,
.warning-area {
  display: flex;
  align-items: center;
  gap: 8px;
}
.level-text {
  color: #ffcc00;
  font-weight: bold;
  font-size: 18px;
  text-shadow: 0 0 10px rgba(255, 204, 0, 0.5);
}
.index-text {
  color: #2a8ef1;
  font-weight: bold;
  font-size: 18px;
  text-shadow: 0 0 10px rgba(42, 142, 241, 0.5);
}
.warning-time,
.warning-area {
  color: #b0b0b0;
}
.logout-btn {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: bold !important;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.3s ease;
  background: rgba(42, 142, 241, 0.3);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid rgba(42, 142, 241, 0.5);
}
.logout-btn:hover {
  background: rgba(42, 142, 241, 0.5);
  color: #ffffff !important;
  transform: translateY(-50%) scale(1.05);
  box-shadow: 0 0 10px rgba(42, 142, 241, 0.5);
}
.logout-btn i {
  margin-right: 5px;
}
.moduleContent::-webkit-scrollbar {
  width: 6px;
}
.moduleContent::-webkit-scrollbar-track {
  background: rgba(14, 18, 45, 0.5);
  border-radius: 3px;
}
.moduleContent::-webkit-scrollbar-thumb {
  background: #2a8ef1;
  border-radius: 3px;
}
.moduleContent::-webkit-scrollbar-thumb:hover {
  background: #0066cc;
}
.el-table {
  font-size: 12px;
  color: #ffffff;
  background-color: transparent;
}
.el-table th {
  background: linear-gradient(
    135deg,
    rgba(42, 142, 241, 0.3) 0%,
    rgba(42, 142, 241, 0.1) 100%
  );
  color: #ffffff;
  font-weight: bold;
  border-bottom: 1px solid rgba(42, 142, 241, 0.3);
}
.el-table th.is-leaf {
  border-bottom: 1px solid rgba(42, 142, 241, 0.3);
}
.el-table td {
  border-bottom: 1px solid rgba(42, 142, 241, 0.2);
  color: #ffffff;
}
.el-table tr {
  background-color: transparent;
}
.el-table tr:hover {
  background-color: rgba(42, 142, 241, 0.15);
}
.el-table .el-table__header-wrapper th {
  background-color: #162a50 !important;
  color: #ffffff !important;
}
.el-table .el-table__header-wrapper th .cell {
  color: #ffffff !important;
}
.el-table .el-table__body-wrapper td {
  background-color: transparent !important;
}
.el-table .el-table__body tr {
  background-color: transparent !important;
}
.el-table .el-table__body tr:hover {
  background-color: rgba(42, 142, 241, 0.15) !important;
}
.el-table .el-table__body tr.table-row-even {
  background-color: transparent !important;
}
.el-table .el-table__body tr.table-row-odd {
  background-color: transparent !important;
}
.el-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: bold;
}
.el-tag--success {
  background-color: rgba(46, 204, 113, 0.2);
  border-color: rgba(46, 204, 113, 0.4);
  color: #2ecc71;
}
.el-tag--danger {
  background-color: rgba(231, 76, 60, 0.2);
  border-color: rgba(231, 76, 60, 0.4);
  color: #e74c3c;
}
.rightBox .moduleBox {
  flex: none;
  height: 24%;
}
.rightBox .moduleContent {
  flex: none;
  height: 75%;
  padding: 8px;
}
#radarChart {
  width: 100% !important;
  height: 120px !important;
}
#barChart {
  width: 100% !important;
  height: 100% !important;
}
.centerBox {
  position: relative;
}
.centerBox::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(42, 142, 241, 0.5),
    transparent
  );
}
.map-container {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}
.map-reset-btn {
  position: absolute;
  bottom: 60px;
  right: 16px;
  z-index: 1000;
  width: 34px;
  height: 34px;
  background: rgba(14, 18, 45, 0.95);
  border: 1px solid rgba(42, 142, 241, 0.4);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffffff;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
.map-reset-btn:hover {
  border-color: #2a8ef1;
  color: #2a8ef1;
  box-shadow: 0 0 10px rgba(42, 142, 241, 0.4);
}
.leaflet-container {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.progress-control {
  position: absolute !important;
  bottom: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 1000 !important;
  float: none !important;
  margin: 0 !important;
}
.progress-control-custom {
  position: absolute !important;
  bottom: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 1000 !important;
  float: none !important;
  margin: 0 !important;
}
.leaflet-bottom.leaflet-left {
  position: absolute !important;
  bottom: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 1000 !important;
}
.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background: rgba(14, 18, 45, 0.9);
  padding: 15px 25px;
  border-radius: 10px;
  border: 1px solid rgba(42, 142, 241, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}
.progress-bar {
  width: 300px;
  height: 8px;
  background: rgba(42, 142, 241, 0.2);
  border-radius: 4px;
  overflow: hidden;
}
.progress-fill {
  width: 0%;
  height: 100%;
  background: linear-gradient(90deg, #2a8ef1 0%, #0066cc 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
}
.progress-buttons {
  display: flex;
  align-items: center;
  gap: 15px;
}
.progress-buttons button {
  background: rgba(42, 142, 241, 0.2);
  border: 1px solid #2a8ef1;
  color: #2a8ef1;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.progress-buttons button:hover {
  background: rgba(42, 142, 241, 0.4);
  box-shadow: 0 0 10px rgba(42, 142, 241, 0.5);
}
.progress-text {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}
.data-selector{
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 999;
  background: rgba(14, 18, 45, 0.95);
  backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid rgba(42, 142, 241, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}
.data-selector .el-radio-button {
  margin-right: 10px;
}
.data-selector .el-radio-button:last-child {
  margin-right: 0;
}
.data-selector .el-radio-button__inner {
  background: rgba(14, 18, 45, 0.9);
  border-color: rgba(42, 142, 241, 0.3);
  color: #ffffff;
  font-size: 14px;
  padding: 8px 20px;
  border-radius: 20px;
  transition: all 0.3s ease;
  border-left: none;
  margin-left: -1px;
}
.data-selector .el-radio-button__inner:first-child {
  border-left: 1px solid rgba(42, 142, 241, 0.3);
  margin-left: 0;
}
.data-selector .el-radio-button__inner:hover {
  border-color: #2a8ef1;
  color: #2a8ef1;
  box-shadow: 0 0 10px rgba(42, 142, 241, 0.3);
}
.data-selector .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: rgba(42, 142, 241, 0.2);
  border-color: #2a8ef1;
  color: #2a8ef1;
  box-shadow: 0 0 15px rgba(42, 142, 241, 0.5);
}
.map-controls {
  position: absolute;
  top: 80px;
  left: 20px;
  z-index: 999;
  background: rgba(14, 18, 45, 0.95);
  backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid rgba(42, 142, 241, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}
.map-controls .el-radio-group {
  display: flex;
  flex-direction: column;
}
.map-controls .el-radio-button {
  margin-right: 0;
  margin-bottom: 8px;
}
.map-controls .el-radio-button:last-child {
  margin-bottom: 0;
}
.map-controls .el-radio-button__inner {
  background: rgba(14, 18, 45, 0.9);
  border-color: rgba(42, 142, 241, 0.3);
  color: #ffffff;
  font-size: 14px;
  padding: 8px 20px;
  border-radius: 20px;
  transition: all 0.3s ease;
  width: 100%;
  text-align: center;
  border-left: 1px solid rgba(42, 142, 241, 0.3);
  margin-left: 0;
}
.map-controls .el-radio-button__inner:hover {
  border-color: #2a8ef1;
  color: #2a8ef1;
  box-shadow: 0 0 10px rgba(42, 142, 241, 0.3);
}
.map-controls .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: rgba(42, 142, 241, 0.2);
  border-color: #2a8ef1;
  color: #2a8ef1;
  box-shadow: 0 0 15px rgba(42, 142, 241, 0.5);
}
</style>
